/* 固定ヘッダーの実寸を測って CSS 変数に反映（記事ページ用） */
(function () {
  function setHeaderSafe() {
    var header = document.querySelector('.shopify-section--header');
    if (!header) return;
    var h = header.offsetHeight || 0;
    // 750px 未満（SP）だけ余白を入れる。PC幅では 0 に。
    if (window.matchMedia('(max-width: 749px)').matches) {
      document.documentElement.style.setProperty('--header-safe', h + 'px');
    } else {
      document.documentElement.style.setProperty('--header-safe', '0px');
    }
  }

  document.addEventListener('DOMContentLoaded', setHeaderSafe);
  window.addEventListener('resize', setHeaderSafe);

  // ヘッダー内の高さ変化（検索やバー開閉）にも追従
  if ('ResizeObserver' in window) {
    var header = document.querySelector('.shopify-section--header');
    if (header) {
      var ro = new ResizeObserver(setHeaderSafe);
      ro.observe(header);
    }
  }
})();
